import { Theme } from '@mui/material';

import { TYPOGRAPHY_VARIANTS } from '../typography/typography';

export const getToolTipStyles = (theme: Theme) => ({
  ...TYPOGRAPHY_VARIANTS['text-xs-semibold'],
  backgroundColor: theme.backrs.colors['Colors/Background/bg-primary-solid'],
  padding: theme.backrs.spacing['spacing-md'],
  borderRadius: theme.backrs.radius['radius-md'],
  opacity: 1,
});

export const getToolTipArrowStyles = (theme: Theme) => ({
  color: theme.backrs.colors['Colors/Background/bg-primary-solid'],
});
